import { FunctionComponent, HTMLAttributes } from 'react';
import styled from 'styled-components';

import { LANGUAGE_LABELS } from '../constants/labels';
import { SUPPORTED_LANGUAGE_OPTIONS } from '../constants/options'
import { useComponentVisible } from '../hooks'
import { useTranslation } from 'react-i18next';
import { MOBILE_DEVICE } from '../constants/styles';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`

const Text = styled.span`
  font: normal normal normal 14px/24px Hiragino Kaku Gothic ProN;
  color: #2C2C2C;
`

interface MenuProps {
    visible?: boolean;
}

const Menu = styled.div<MenuProps>`
  position: absolute;
  top: 50%;
  right: 0;
  background: white;
  box-shadow: 2px 2px 8px 4px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  z-index: 5;
  visibility: ${(props: MenuProps) => props.visible ? 'visible' : 'hidden'};
  
  > *:first-child {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
  }
  
  > *:last-child {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  
  @media ${MOBILE_DEVICE} {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    
    > * {
      border-bottom: 1px solid #D5D5D5;
    }
  }
`

const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  padding-left: 10px;
  width: 142px;
  height: 38px;
  font: normal normal normal 14px/24px Hiragino Kaku Gothic ProN;
  color: #2C2C2C;
  
  &:hover {
    color: white;
    background: #FF730D;
  }
  
  @media ${MOBILE_DEVICE} {
    width: 100%;
    height: 48px;
  }
`

interface LanguageSelectorProps extends HTMLAttributes<HTMLDivElement> {
}

const LanguageSelector: FunctionComponent<LanguageSelectorProps> = ({
    ...props
}) => {
    const { i18n } = useTranslation();
    const { ref, visible, setVisible } = useComponentVisible(false)

    const handleClick = (language: string) => {
        setVisible(false)
        i18n.changeLanguage(language);
        localStorage.setItem('lng', language);
    }

    return (
        <Container onClick={() => setVisible(true)} {...props}>
            <img alt="globe icon" src="/images/icon-globe.svg"/>
            <Text>{LANGUAGE_LABELS[i18n.language]}</Text>
            <Menu ref={ref} visible={visible}>
                {SUPPORTED_LANGUAGE_OPTIONS.map((item) => (
                    <Item
                        key={item.value}
                        onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            handleClick(item.value);
                        }}
                    >
                        {item.label}
                    </Item>
                ))}
            </Menu>
        </Container>
    )
}

export default LanguageSelector